"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceHeader = class UcInvoiceHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    invoiceNumber;
    onInvoice_number(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoiceNumber");
    }
    formContext;
    onForm_context(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formContext");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    newTransaction: this.$fn.pgettext("Invoice", "New Invoice"),
                    invoiceKind: {
                        incoming: this.$fn.pgettext("InvoiceKind", "Incoming Invoice"),
                        outgoing: this.$fn.pgettext("InvoiceKind", "Outgoing Invoice"),
                    },
                    createCorrectorTooltip: this.$fn.pgettext("Invoice", "Create corrector invoice"),
                    createStornoTooltip: this.$fn.pgettext("Invoice", "Create storno invoice"),
                    createPassThroughTooltip: this.$fn.pgettext("Invoice|Tooltip", "Rebilling the line items to a designated client."),
                    createAdvanceInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create advance invoice from a Pro Forma invoice."),
                    createFinalInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create final invoice from a Pro Forma or advance invoice."),
                },
                ux: null,
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.messages.invoiceKind[this.invoice.invoice_kind];
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.invoiceNumber || (this.invoice.isNew ? this.messages.newTransaction : this.invoice.invoice_number);
        }
        return null;
    }
    get createCorrectorTooltip() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.modifiable.message') || this.messages.createCorrectorTooltip;
        }
        return null;
    }
    get createStornoTooltip() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.reversible.message') || this.messages.createStornoTooltip;
        }
        return null;
    }
    get invoiceIsReversible() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.reversible.result');
        }
        return null;
    }
    get invoiceIsModifiable() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.modifiable.result');
        }
        return null;
    }
    get invoiceIsRegistrable() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.registrable.result');
        }
        return null;
    }
    get invoicePassThroughIsEnabled() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.pass_through_enabled') === true ||
                _.get(this.invoice, 'meta.pass_through_enabled.result');
        }
        return null;
    }
    get canCreateAdvanceInvoice() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.can_create_advance_invoice') === true;
        }
        return null;
    }
    get canCreateFinalInvoice() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.can_create_final_invoice') === true;
        }
        return null;
    }
    async act_1048678296148443_emit_7546_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1048678296148443_reload(event, scope) {
        return await this.actions.evh_1048678296148443_reload.executeFromDOM(this, event, scope);
    }
    async act_6639903447389385_emit_7548_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_6639903447389385_success(event, scope) {
        return await this.actions.evh_6639903447389385_success.executeFromDOM(this, event, scope);
    }
    async act_3803044933457651_emit_7550_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3803044933457651_success(event, scope) {
        return await this.actions.evh_3803044933457651_success.executeFromDOM(this, event, scope);
    }
    async act_4764767232201234_emit_7552_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4764767232201234_success(event, scope) {
        return await this.actions.evh_4764767232201234_success.executeFromDOM(this, event, scope);
    }
    async act_7992484462910578_emit_7554_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7992484462910578_success(event, scope) {
        return await this.actions.evh_7992484462910578_success.executeFromDOM(this, event, scope);
    }
    async act_7716964648426498_emit_7558_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7716964648426498_close_7557_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_7716964648426498_showModal_7556_getActionArgs($event) {
        return {
            name: "InvoiceEditor",
            props: {
                invoice: _.cloneDeep(this.invoice),
            },
        };
    }
    async evh_7716964648426498_clickPreventStop(event, scope) {
        return await this.actions.evh_7716964648426498_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2940653511262489_emit_7560_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_2940653511262489_clickPreventStop(event, scope) {
        return await this.actions.evh_2940653511262489_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_689536327456849_emit_7562_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_689536327456849_clickPreventStop(event, scope) {
        return await this.actions.evh_689536327456849_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8254501898831426_showModal_7564_getActionArgs($event) {
        return {
            name: "InvoiceLogMessageViewer",
            props: {
                invoiceId: this.invoice.id,
            },
        };
    }
    async evh_8254501898831426_clickPreventStop(event, scope) {
        return await this.actions.evh_8254501898831426_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_951936257455896_emit_7568_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_951936257455896_close_7567_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_951936257455896_showModal_7566_getActionArgs($event) {
        return {
            name: "RegisterEntry",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_951936257455896_click(event, scope) {
        return await this.actions.evh_951936257455896_click.executeFromDOM(this, event, scope);
    }
    async act_7010716094810887_emit_7572_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_7010716094810887_request_7570_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'copy' },
        };
    }
    async evh_7010716094810887_click(event, scope) {
        return await this.actions.evh_7010716094810887_click.executeFromDOM(this, event, scope);
    }
    async act_4971252216919813_emit_7576_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4971252216919813_close_7575_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_4971252216919813_showModal_7574_getActionArgs($event) {
        return {
            name: "CreatePassThroughInvoice",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_4971252216919813_click(event, scope) {
        return await this.actions.evh_4971252216919813_click.executeFromDOM(this, event, scope);
    }
    async act_3581444176199717_emit_7580_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_3581444176199717_request_7578_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'advance' },
        };
    }
    async evh_3581444176199717_click(event, scope) {
        return await this.actions.evh_3581444176199717_click.executeFromDOM(this, event, scope);
    }
    async act_6391442819935878_emit_7584_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_6391442819935878_request_7582_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'final' },
        };
    }
    async evh_6391442819935878_click(event, scope) {
        return await this.actions.evh_6391442819935878_click.executeFromDOM(this, event, scope);
    }
    async act_2988515090283815_emit_7588_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_2988515090283815_request_7586_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'storno' },
        };
    }
    async evh_2988515090283815_click(event, scope) {
        return await this.actions.evh_2988515090283815_click.executeFromDOM(this, event, scope);
    }
    async act_3478991899028773_emit_7592_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_3478991899028773_request_7590_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: {
                invoice_id: this.invoice.id,
                invoice_type: 'correction',
                invoice_lines: _.map(this.formContext.selectedInvoiceLines, p => p.id).join(',')
            },
        };
    }
    async evh_3478991899028773_click(event, scope) {
        return await this.actions.evh_3478991899028773_click.executeFromDOM(this, event, scope);
    }
    async act_8376575288437415_emit_7594_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8376575288437415_success(event, scope) {
        return await this.actions.evh_8376575288437415_success.executeFromDOM(this, event, scope);
    }
    async act_3958027742391354_emit_7596_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_3958027742391354_success(event, scope) {
        return await this.actions.evh_3958027742391354_success.executeFromDOM(this, event, scope);
    }
    async act_8122162285230843_showModal_7598_getActionArgs($event) {
        return {
            name: "entityEvents",
            props: {
                entityId: this.invoice.id,
            },
        };
    }
    async evh_8122162285230843_clickPreventStop(event, scope) {
        return await this.actions.evh_8122162285230843_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1048678296148443_emit_7546 = new core_1.actions.EmitAction({
            actionArgs: this.act_1048678296148443_emit_7546_getActionArgs,
            events: [],
        });
        const evh_1048678296148443_reload_7545 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_emit_7546,
            event: "reload",
            displayName: "emit",
        });
        const evh_1048678296148443_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1048678296148443_reload_7545],
        });
        const act_6639903447389385_emit_7548 = new core_1.actions.EmitAction({
            actionArgs: this.act_6639903447389385_emit_7548_getActionArgs,
            events: [],
        });
        const evh_6639903447389385_success_7547 = new core_1.actions.EventHandlerImpl({
            action: act_6639903447389385_emit_7548,
            event: "success",
            displayName: "emit",
        });
        const evh_6639903447389385_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6639903447389385_success_7547],
        });
        const act_3803044933457651_emit_7550 = new core_1.actions.EmitAction({
            actionArgs: this.act_3803044933457651_emit_7550_getActionArgs,
            events: [],
        });
        const evh_3803044933457651_success_7549 = new core_1.actions.EventHandlerImpl({
            action: act_3803044933457651_emit_7550,
            event: "success",
            displayName: "emit",
        });
        const evh_3803044933457651_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3803044933457651_success_7549],
        });
        const act_4764767232201234_emit_7552 = new core_1.actions.EmitAction({
            actionArgs: this.act_4764767232201234_emit_7552_getActionArgs,
            events: [],
        });
        const evh_4764767232201234_success_7551 = new core_1.actions.EventHandlerImpl({
            action: act_4764767232201234_emit_7552,
            event: "success",
            displayName: "emit",
        });
        const evh_4764767232201234_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4764767232201234_success_7551],
        });
        const act_7992484462910578_emit_7554 = new core_1.actions.EmitAction({
            actionArgs: this.act_7992484462910578_emit_7554_getActionArgs,
            events: [],
        });
        const evh_7992484462910578_success_7553 = new core_1.actions.EventHandlerImpl({
            action: act_7992484462910578_emit_7554,
            event: "success",
            displayName: "emit",
        });
        const evh_7992484462910578_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7992484462910578_success_7553],
        });
        const act_7716964648426498_emit_7558 = new core_1.actions.EmitAction({
            actionArgs: this.act_7716964648426498_emit_7558_getActionArgs,
            events: [],
        });
        const evh_7716964648426498_close_7557 = new core_1.actions.EventHandlerImpl({
            action: act_7716964648426498_emit_7558,
            event: "close",
            when: this.evh_7716964648426498_close_7557_getWhen,
            displayName: "emit",
        });
        const act_7716964648426498_showModal_7556 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7716964648426498_showModal_7556_getActionArgs,
            events: [evh_7716964648426498_close_7557],
        });
        const evh_7716964648426498_clickPreventStop_7555 = new core_1.actions.EventHandlerImpl({
            action: act_7716964648426498_showModal_7556,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_7716964648426498_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7716964648426498_clickPreventStop_7555],
        });
        const act_2940653511262489_emit_7560 = new core_1.actions.EmitAction({
            actionArgs: this.act_2940653511262489_emit_7560_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_2940653511262489_clickPreventStop_7559 = new core_1.actions.EventHandlerImpl({
            action: act_2940653511262489_emit_7560,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_2940653511262489_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2940653511262489_clickPreventStop_7559],
        });
        const act_689536327456849_emit_7562 = new core_1.actions.EmitAction({
            actionArgs: this.act_689536327456849_emit_7562_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_689536327456849_clickPreventStop_7561 = new core_1.actions.EventHandlerImpl({
            action: act_689536327456849_emit_7562,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_689536327456849_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_689536327456849_clickPreventStop_7561],
        });
        const act_8254501898831426_showModal_7564 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8254501898831426_showModal_7564_getActionArgs,
            events: [],
        });
        const evh_8254501898831426_clickPreventStop_7563 = new core_1.actions.EventHandlerImpl({
            action: act_8254501898831426_showModal_7564,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8254501898831426_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8254501898831426_clickPreventStop_7563],
        });
        const act_951936257455896_emit_7568 = new core_1.actions.EmitAction({
            actionArgs: this.act_951936257455896_emit_7568_getActionArgs,
            events: [],
        });
        const evh_951936257455896_close_7567 = new core_1.actions.EventHandlerImpl({
            action: act_951936257455896_emit_7568,
            event: "close",
            when: this.evh_951936257455896_close_7567_getWhen,
            displayName: "emit",
        });
        const act_951936257455896_showModal_7566 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_951936257455896_showModal_7566_getActionArgs,
            displayName: "registerInvoice",
            events: [evh_951936257455896_close_7567],
        });
        const evh_951936257455896_click_7565 = new core_1.actions.EventHandlerImpl({
            action: act_951936257455896_showModal_7566,
            event: "click",
            displayName: "registerInvoice",
        });
        const evh_951936257455896_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_951936257455896_click_7565],
        });
        const act_7010716094810887_emit_7572 = new core_1.actions.EmitAction({
            actionArgs: this.act_7010716094810887_emit_7572_getActionArgs,
            events: [],
        });
        const evh_7010716094810887_success_7571 = new core_1.actions.EventHandlerImpl({
            action: act_7010716094810887_emit_7572,
            event: "success",
            displayName: "emit",
        });
        const act_7010716094810887_request_7570 = new core_1.actions.RequestAction({
            actionArgs: this.act_7010716094810887_request_7570_getActionArgs,
            displayName: "createInvoicecopy",
            events: [evh_7010716094810887_success_7571],
        });
        const evh_7010716094810887_click_7569 = new core_1.actions.EventHandlerImpl({
            action: act_7010716094810887_request_7570,
            event: "click",
            displayName: "createInvoicecopy",
        });
        const evh_7010716094810887_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7010716094810887_click_7569],
        });
        const act_4971252216919813_emit_7576 = new core_1.actions.EmitAction({
            actionArgs: this.act_4971252216919813_emit_7576_getActionArgs,
            events: [],
        });
        const evh_4971252216919813_close_7575 = new core_1.actions.EventHandlerImpl({
            action: act_4971252216919813_emit_7576,
            event: "close",
            when: this.evh_4971252216919813_close_7575_getWhen,
            displayName: "emit",
        });
        const act_4971252216919813_showModal_7574 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4971252216919813_showModal_7574_getActionArgs,
            displayName: "createPassThroughInvoice",
            events: [evh_4971252216919813_close_7575],
        });
        const evh_4971252216919813_click_7573 = new core_1.actions.EventHandlerImpl({
            action: act_4971252216919813_showModal_7574,
            event: "click",
            displayName: "createPassThroughInvoice",
        });
        const evh_4971252216919813_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4971252216919813_click_7573],
        });
        const act_3581444176199717_emit_7580 = new core_1.actions.EmitAction({
            actionArgs: this.act_3581444176199717_emit_7580_getActionArgs,
            events: [],
        });
        const evh_3581444176199717_success_7579 = new core_1.actions.EventHandlerImpl({
            action: act_3581444176199717_emit_7580,
            event: "success",
            displayName: "emit",
        });
        const act_3581444176199717_request_7578 = new core_1.actions.RequestAction({
            actionArgs: this.act_3581444176199717_request_7578_getActionArgs,
            displayName: "createAdvanceInvoice",
            events: [evh_3581444176199717_success_7579],
        });
        const evh_3581444176199717_click_7577 = new core_1.actions.EventHandlerImpl({
            action: act_3581444176199717_request_7578,
            event: "click",
            displayName: "createAdvanceInvoice",
        });
        const evh_3581444176199717_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3581444176199717_click_7577],
        });
        const act_6391442819935878_emit_7584 = new core_1.actions.EmitAction({
            actionArgs: this.act_6391442819935878_emit_7584_getActionArgs,
            events: [],
        });
        const evh_6391442819935878_success_7583 = new core_1.actions.EventHandlerImpl({
            action: act_6391442819935878_emit_7584,
            event: "success",
            displayName: "emit",
        });
        const act_6391442819935878_request_7582 = new core_1.actions.RequestAction({
            actionArgs: this.act_6391442819935878_request_7582_getActionArgs,
            displayName: "createFinalInvoice",
            events: [evh_6391442819935878_success_7583],
        });
        const evh_6391442819935878_click_7581 = new core_1.actions.EventHandlerImpl({
            action: act_6391442819935878_request_7582,
            event: "click",
            displayName: "createFinalInvoice",
        });
        const evh_6391442819935878_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6391442819935878_click_7581],
        });
        const act_2988515090283815_emit_7588 = new core_1.actions.EmitAction({
            actionArgs: this.act_2988515090283815_emit_7588_getActionArgs,
            events: [],
        });
        const evh_2988515090283815_success_7587 = new core_1.actions.EventHandlerImpl({
            action: act_2988515090283815_emit_7588,
            event: "success",
            displayName: "emit",
        });
        const act_2988515090283815_request_7586 = new core_1.actions.RequestAction({
            actionArgs: this.act_2988515090283815_request_7586_getActionArgs,
            displayName: "createStornoInvoice",
            events: [evh_2988515090283815_success_7587],
        });
        const evh_2988515090283815_click_7585 = new core_1.actions.EventHandlerImpl({
            action: act_2988515090283815_request_7586,
            event: "click",
            displayName: "createStornoInvoice",
        });
        const evh_2988515090283815_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2988515090283815_click_7585],
        });
        const act_3478991899028773_emit_7592 = new core_1.actions.EmitAction({
            actionArgs: this.act_3478991899028773_emit_7592_getActionArgs,
            events: [],
        });
        const evh_3478991899028773_success_7591 = new core_1.actions.EventHandlerImpl({
            action: act_3478991899028773_emit_7592,
            event: "success",
            displayName: "emit",
        });
        const act_3478991899028773_request_7590 = new core_1.actions.RequestAction({
            actionArgs: this.act_3478991899028773_request_7590_getActionArgs,
            displayName: "createCorrectorIvoice",
            events: [evh_3478991899028773_success_7591],
        });
        const evh_3478991899028773_click_7589 = new core_1.actions.EventHandlerImpl({
            action: act_3478991899028773_request_7590,
            event: "click",
            displayName: "createCorrectorIvoice",
        });
        const evh_3478991899028773_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3478991899028773_click_7589],
        });
        const act_8376575288437415_emit_7594 = new core_1.actions.EmitAction({
            actionArgs: this.act_8376575288437415_emit_7594_getActionArgs,
            events: [],
        });
        const evh_8376575288437415_success_7593 = new core_1.actions.EventHandlerImpl({
            action: act_8376575288437415_emit_7594,
            event: "success",
            displayName: "emit",
        });
        const evh_8376575288437415_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8376575288437415_success_7593],
        });
        const act_3958027742391354_emit_7596 = new core_1.actions.EmitAction({
            actionArgs: this.act_3958027742391354_emit_7596_getActionArgs,
            events: [],
        });
        const evh_3958027742391354_success_7595 = new core_1.actions.EventHandlerImpl({
            action: act_3958027742391354_emit_7596,
            event: "success",
            displayName: "emit",
        });
        const evh_3958027742391354_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3958027742391354_success_7595],
        });
        const act_8122162285230843_showModal_7598 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8122162285230843_showModal_7598_getActionArgs,
            events: [],
        });
        const evh_8122162285230843_clickPreventStop_7597 = new core_1.actions.EventHandlerImpl({
            action: act_8122162285230843_showModal_7598,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8122162285230843_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8122162285230843_clickPreventStop_7597],
        });
        return {
            act_1048678296148443_emit_7546,
            evh_1048678296148443_reload_7545,
            evh_1048678296148443_reload,
            act_6639903447389385_emit_7548,
            evh_6639903447389385_success_7547,
            evh_6639903447389385_success,
            act_3803044933457651_emit_7550,
            evh_3803044933457651_success_7549,
            evh_3803044933457651_success,
            act_4764767232201234_emit_7552,
            evh_4764767232201234_success_7551,
            evh_4764767232201234_success,
            act_7992484462910578_emit_7554,
            evh_7992484462910578_success_7553,
            evh_7992484462910578_success,
            act_7716964648426498_emit_7558,
            evh_7716964648426498_close_7557,
            act_7716964648426498_showModal_7556,
            evh_7716964648426498_clickPreventStop_7555,
            evh_7716964648426498_clickPreventStop,
            act_2940653511262489_emit_7560,
            evh_2940653511262489_clickPreventStop_7559,
            evh_2940653511262489_clickPreventStop,
            act_689536327456849_emit_7562,
            evh_689536327456849_clickPreventStop_7561,
            evh_689536327456849_clickPreventStop,
            act_8254501898831426_showModal_7564,
            evh_8254501898831426_clickPreventStop_7563,
            evh_8254501898831426_clickPreventStop,
            act_951936257455896_emit_7568,
            evh_951936257455896_close_7567,
            act_951936257455896_showModal_7566,
            evh_951936257455896_click_7565,
            evh_951936257455896_click,
            act_7010716094810887_emit_7572,
            evh_7010716094810887_success_7571,
            act_7010716094810887_request_7570,
            evh_7010716094810887_click_7569,
            evh_7010716094810887_click,
            act_4971252216919813_emit_7576,
            evh_4971252216919813_close_7575,
            act_4971252216919813_showModal_7574,
            evh_4971252216919813_click_7573,
            evh_4971252216919813_click,
            act_3581444176199717_emit_7580,
            evh_3581444176199717_success_7579,
            act_3581444176199717_request_7578,
            evh_3581444176199717_click_7577,
            evh_3581444176199717_click,
            act_6391442819935878_emit_7584,
            evh_6391442819935878_success_7583,
            act_6391442819935878_request_7582,
            evh_6391442819935878_click_7581,
            evh_6391442819935878_click,
            act_2988515090283815_emit_7588,
            evh_2988515090283815_success_7587,
            act_2988515090283815_request_7586,
            evh_2988515090283815_click_7585,
            evh_2988515090283815_click,
            act_3478991899028773_emit_7592,
            evh_3478991899028773_success_7591,
            act_3478991899028773_request_7590,
            evh_3478991899028773_click_7589,
            evh_3478991899028773_click,
            act_8376575288437415_emit_7594,
            evh_8376575288437415_success_7593,
            evh_8376575288437415_success,
            act_3958027742391354_emit_7596,
            evh_3958027742391354_success_7595,
            evh_3958027742391354_success,
            act_8122162285230843_showModal_7598,
            evh_8122162285230843_clickPreventStop_7597,
            evh_8122162285230843_clickPreventStop,
            reload: act_689536327456849_emit_7562,
            registerInvoice: act_951936257455896_showModal_7566,
            createInvoicecopy: act_7010716094810887_request_7570,
            createPassThroughInvoice: act_4971252216919813_showModal_7574,
            createAdvanceInvoice: act_3581444176199717_request_7578,
            createFinalInvoice: act_6391442819935878_request_7582,
            createStornoInvoice: act_2988515090283815_request_7586,
            createCorrectorIvoice: act_3478991899028773_request_7590,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceHeader.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], UcInvoiceHeader.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcInvoiceHeader.prototype, "invoiceNumber", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoiceNumber'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onInvoice_number", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceHeader.prototype, "formContext", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formContext'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onForm_context", null);
UcInvoiceHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceHeader);
exports.default = UcInvoiceHeader;
vue_property_decorator_1.Vue.component("UcInvoiceHeader", UcInvoiceHeader);
